<template>
  <div v-if="pacote" class="card border-0 shadow-sm" style="min-width: 0; overflow: hidden;">
    <div class="card-body p-4 d-flex flex-column" style="gap: 8px;">

      <div class="d-flex align-items-center" style="gap: 8px;">
        <span style="font-size: 20px; line-height: 1; flex-shrink: 0;">🚀</span>
        <div style="min-width: 0;">
          <p class="font-weight-bolder text-dark mb-0 font-size-sm" style="white-space: nowrap; overflow: hidden; text-overflow: ellipsis;">
            Novidades do Sistema Nuts
          </p>
          <span class="text-muted" style="font-size: 11px;" v-if="pacote.versao">
            Versão {{ pacote.versao }}
          </span>
        </div>
      </div>

      <p class="font-weight-bold text-dark-75 mb-0 font-size-sm" style="white-space: nowrap; overflow: hidden; text-overflow: ellipsis;">
        {{ pacote.titulo }}
      </p>

      <p class="text-muted mb-0" style="font-size: 11px; overflow: hidden; display: -webkit-box; -webkit-line-clamp: 2; -webkit-box-orient: vertical;" v-if="pacote.descricao_curta">
        {{ pacote.descricao_curta }}
      </p>

      <div>
        <span class="label label-inline label-light-primary font-weight-bold" style="font-size: 11px;">
          {{ totalItens }} {{ totalItens === 1 ? "novidade disponível" : "novidades disponíveis" }}
        </span>
      </div>

      <button
        class="btn btn-primary btn-sm btn-block font-weight-bolder"
        style="font-size: 11px;"
        @click="$emit('ver-novidades', pacote)"
      >
        Ver novidades
      </button>

    </div>
  </div>
</template>

<script>
export default {
  name: "CardNovidades",
  props: {
    pacote: {
      type: Object,
      default: null,
    },
  },
  computed: {
    totalItens() {
      return this.pacote && this.pacote.itens ? this.pacote.itens.length : 0;
    },
  },
};
</script>
